import { render, staticRenderFns } from "./IdiomaPage.vue?vue&type=template&id=54583739"
import script from "./IdiomaPage.js?vue&type=script&lang=js&external"
export * from "./IdiomaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports